import classNames from 'classnames/bind';
import React from 'react';
import styles from './styles.module.scss';
import Hand from '../../../public/static/images/Home/HandWaving/hand.svg';

const cx = classNames.bind(styles);

interface IHandWavingProps {
    className: string;
}

const HandWaving = ({ className }: IHandWavingProps) => {
  const rootClass = cx({
    [className]: className !== undefined,
    [styles.Root]: true,
  });

  return (
    <div className={ rootClass }>
      <span className={ styles.Hand }>
        <Hand />
      </span>
    </div>
  );
};

export default HandWaving;
